export default "__VITE_ASSET__DTnTtQHT__"